"use client";

import { c as _c } from "react/compiler-runtime";
import { AlignHorizontalDistributeCenterIcon, AlignHorizontalDistributeEndIcon, AlignHorizontalDistributeStartIcon } from "lucide-react";
import { nanoid } from "nanoid";
import { useState } from "react";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { useDidUpdate } from "@/ui/hooks/lifecycle";
import { useRouterRefresh } from "@/ui/hooks/use-router-refresh";
import { ImageUploadLight } from "@/ui/image-upload/image-upload-light";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/ui/shadcn/select";
import { useStartGlobalTransition } from "@/zustand/admin";
import { CompactButtonGroup } from "../../shared/compact-button-group";
export const GalleryForm = t0 => {
  const $ = _c(53);
  const {
    data
  } = t0;
  let t1;
  if ($[0] !== data?.photos) {
    t1 = data?.photos ?? [];
    $[0] = data?.photos;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [images, setImages] = useState(t1);
  const context = useStoreBuilderContext();
  const refresh = useRouterRefresh();
  const startGlobalTransition = useStartGlobalTransition();
  let t2;
  if ($[2] !== context || $[3] !== images) {
    t2 = () => {
      context.saveSelectedPageSectionField({
        fieldPath: "photos",
        value: images
      });
    };
    $[2] = context;
    $[3] = images;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== images) {
    t3 = [images];
    $[5] = images;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  useDidUpdate(t2, t3);
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-xs text-neutral-600 font-medium">Columns</span>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      value: "1",
      icon: <span className="text-xs font-medium">1</span>,
      tooltip: "1 column"
    };
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      value: "2",
      icon: <span className="text-xs font-medium">2</span>,
      tooltip: "2 columns"
    };
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      value: "3",
      icon: <span className="text-xs font-medium">3</span>,
      tooltip: "3 columns"
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      value: "4",
      icon: <span className="text-xs font-medium">4</span>,
      tooltip: "4 columns"
    };
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [t5, t6, t7, t8, {
      value: "6",
      icon: <span className="text-xs font-medium">6</span>,
      tooltip: "6 columns"
    }];
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = data?.columns || 3;
  let t11;
  if ($[13] !== t10) {
    t11 = t10.toString();
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== context || $[16] !== refresh || $[17] !== startGlobalTransition) {
    t12 = async value => startGlobalTransition(async () => {
      await context.saveSelectedPageSectionField({
        fieldPath: "columns",
        value: Number.parseInt(value)
      });
      await refresh();
    });
    $[15] = context;
    $[16] = refresh;
    $[17] = startGlobalTransition;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <div className="grid gap-1">{t4}<CompactButtonGroup options={t9} defaultValue={t11} onValueChange={t12} className="w-full" /></div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-xs text-neutral-600 font-medium">Item Distribution</span>;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = {
      value: "start",
      icon: <AlignHorizontalDistributeStartIcon className="size-3" />,
      tooltip: "Start"
    };
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      value: "center",
      icon: <AlignHorizontalDistributeCenterIcon className="size-3" />,
      tooltip: "Center"
    };
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [t15, t16, {
      value: "end",
      icon: <AlignHorizontalDistributeEndIcon className="size-3" />,
      tooltip: "End"
    }];
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = data?.justifyItems ?? "space-between";
  let t19;
  if ($[26] !== context) {
    t19 = value_0 => {
      context.saveSelectedPageSectionField({
        fieldPath: "justifyItems",
        value: value_0
      });
    };
    $[26] = context;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  if ($[28] !== t18 || $[29] !== t19) {
    t20 = <div className="grid gap-1">{t14}<CompactButtonGroup options={t17} defaultValue={t18} onValueChange={t19} className="w-full" /></div>;
    $[28] = t18;
    $[29] = t19;
    $[30] = t20;
  } else {
    t20 = $[30];
  }
  let t21;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <span className="text-xs text-neutral-600 font-medium">Column Gap</span>;
    $[31] = t21;
  } else {
    t21 = $[31];
  }
  const t22 = data?.columnGap ?? "sm";
  let t23;
  if ($[32] !== context) {
    t23 = value_1 => {
      context.saveSelectedPageSectionField({
        fieldPath: "columnGap",
        value: value_1
      });
    };
    $[32] = context;
    $[33] = t23;
  } else {
    t23 = $[33];
  }
  let t24;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <SelectTrigger className="w-full"><SelectValue placeholder="Select gap size" /></SelectTrigger>;
    $[34] = t24;
  } else {
    t24 = $[34];
  }
  let t25;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <SelectContent><SelectItem value="sm">Small</SelectItem><SelectItem value="md">Medium</SelectItem><SelectItem value="lg">Large</SelectItem></SelectContent>;
    $[35] = t25;
  } else {
    t25 = $[35];
  }
  let t26;
  if ($[36] !== t22 || $[37] !== t23) {
    t26 = <div className="grid gap-1">{t21}<Select defaultValue={t22} onValueChange={t23}>{t24}{t25}</Select></div>;
    $[36] = t22;
    $[37] = t23;
    $[38] = t26;
  } else {
    t26 = $[38];
  }
  let t27;
  if ($[39] !== t13 || $[40] !== t20 || $[41] !== t26) {
    t27 = <div className="grid grid-cols-2 gap-2">{t13}{t20}{t26}</div>;
    $[39] = t13;
    $[40] = t20;
    $[41] = t26;
    $[42] = t27;
  } else {
    t27 = $[42];
  }
  let t28;
  if ($[43] !== images) {
    t28 = images.map(_temp);
    $[43] = images;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  let t30;
  let t31;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = newImages => {
      setImages(images_0 => newImages.flatMap(newImageUrl => images_0.find(i_0 => i_0.imageUrl === newImageUrl) ?? []));
    };
    t30 = (image, t32) => {
      const {
        width,
        height
      } = t32;
      setImages(images_1 => [...images_1, {
        id: nanoid(),
        imageUrl: image,
        width,
        height
      }]);
    };
    t31 = image_0 => {
      setImages(images_2 => images_2.filter(existingImage => existingImage.imageUrl !== image_0));
    };
    $[45] = t29;
    $[46] = t30;
    $[47] = t31;
  } else {
    t29 = $[45];
    t30 = $[46];
    t31 = $[47];
  }
  let t32;
  if ($[48] !== t28) {
    t32 = <div className="mt-4"><ImageUploadLight maxImages={99} name="images" images={t28} onReorder={t29} onUpload={t30} onDelete={t31} /></div>;
    $[48] = t28;
    $[49] = t32;
  } else {
    t32 = $[49];
  }
  let t33;
  if ($[50] !== t27 || $[51] !== t32) {
    t33 = <div className="space-y-4">{t27}{t32}</div>;
    $[50] = t27;
    $[51] = t32;
    $[52] = t33;
  } else {
    t33 = $[52];
  }
  return t33;
};
function _temp(i) {
  return i.imageUrl;
}